export const holterStepNames = {
    assignDiaryUploadTask: 'Maak taak om het dagboek later te uploaden',
    cancelHolterExamination: 'holter onderzoek annuleren',
    directConsultationRequest: 'Consult holteronderzoek',
    directExaminationRequest: 'Holter/event onderzoek (op de praktijk)',
    externExaminationRequest: 'Holter/event onderzoek extern',
    holterConfigure: 'Holter instellen',
    holterDiaryUpload: 'Holter dagboek',
    holterExternalAssignToRecipient: 'Maak taak voor geselecteerde uitvoerder om de recorder in te stellen',
    holterFollowUpConsultRequest: 'Holter follow-up consult aanvraag',
    holterReadOut: 'Holter uitlezen',
    holterReadOutDetect: 'Holter gedetecteerd',
    homeExaminationRequest: 'Holter/event onderzoek (thuisservice)',
    performConsult: 'Uitvoeren consult',
    receiveAnalysisFromAnalysisParty: 'Ontvang beoordeling van analysepartij',
    secondRoundAnswer: 'Antwoord aanvullende vraag',
    secondRoundQuestion: 'Aanvullende vraag consult',
    sendNotificationEmailToConfigureHolter: 'Stuur e-mail om Holter te configureren',
    uploadDataFileToAnalysisParty: 'Verstuur data file naar analyse partij',
    uploadDiaryToAnalysisParty: 'Verstuur dagboekje naar analyse partij',
    uploadRecordingToAnalysisParty: 'Verstuur ECG naar analyse partij',
    zorgdomeinExaminationRequest: 'ZorgDomein holter/event onderzoek',
};
